<template>
  <div>
    <a-button type="primary" @click="showAdd" v-if="ableAdd">添加流程节点</a-button>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑流程节点' : '添加流程节点'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-process
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :treeData="treeData"
        :rolesList="rolesList"
        :data="tableData"
      ></add-process>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'countersign'">
          {{ codeToText(record.countersign, ['否', '是']) }}
        </template>
        <template v-if="column.key === 'overtime_auto_check'">
          {{ codeToText(record.overtime_auto_check, ['否', '是']) }}
        </template>
        <template v-if="column.key === 'create_user'">
          {{ codeToText(record.create_user_id, Enum.user.value) }}
        </template>
        <template v-if="column.key === 'depart'">
          <span v-for="(item, index) in record.departList" :key="item.pid">
            <span v-if="index !== 0">、</span>
            {{ item.name }}
          </span>
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button @click="showEdit(record)" v-if="ableEdit">编辑</a-button>
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getProcNode, deleteProcNode } from '@/api/process'
  import { getDept } from '@/api/system_manage/dept'
  import { buildTree } from '@/utils/tree'
  import AddProcess from './addProcess'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'
  import { getRole } from '../../../api/system_manage/role'
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'processNode:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'processNode:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'processNode:delet')
  )
  //1、表格
  const columns = [
    {
      title: '流程节点名称',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '关联部门',
      dataIndex: 'depart',
      key: 'depart',
      align: 'left',
    },
    {
      title: '关联角色',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      dataInObject: 'role'
    },
    {
      title: '是否会签',
      dataIndex: 'countersign',
      key: 'countersign',
      align: 'left',
      width: 100
    },
    {
      title: '超时自动审核',
      dataIndex: 'overtime_auto_check',
      key: 'overtime_auto_check',
      align: 'left',
      width: 120
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      align: 'left',
    },
    {
      title: '创建人',
      dataIndex: 'create_user',
      key: 'create_user',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '190px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })
  const treeData = ref([])
  const rolesList = ref([])

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    loading.value = true
    getProcNode({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data
      pagination.value.total = data.total
    })
    getDept().then(({ data }) => {
      const tree = buildTree(data, { idName: 'depart_id' })
      treeData.value = tree
    })
    getRole().then((res) => {
      if (res.success) {
        rolesList.value = res.data.map((role) => ({
          value: role.role_id,
          label: role.name,
        }))
      }
    })
  }
  onMounted(fetch)

  //2、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAdd = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEdit = (data) => {
    editData.value = data
    isEdit.value = true
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //3、删除
  async function delRow(data) {
    const res = await deleteProcNode({ processNodeId: data.process_node_id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
